import dynamic from "next/dynamic";
import type { ReactNode } from "react";
import Footer from "./Footer";
import Navbar from "./Navbar";

const CookieConsent = dynamic(() => import("./CookieConsent"), { ssr: false });

type LayoutProps = {
  children: ReactNode;
};

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-white text-base text-gray-900">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <CookieConsent />
    </div>
  );
}
